/* eslint-disable better-mutation/no-mutation */
import { isServer } from 'tradera/utils/nextjs';

if (isServer) {
    // Do not remove this without also removing the disable of eslint better-mutation/no-mutation at top of file.
    throw new Error(
        'This implementation is not compatible with SSR as global properties are shared between server instances'
    );
}

const antiForgeryToken = {};

antiForgeryToken.set = function (initData) {
    antiForgeryToken._value = initData.antiForgeryToken;
};

antiForgeryToken.get = function () {
    return antiForgeryToken._value;
};

antiForgeryToken.addToAjaxRequest = function (options) {
    options.headers = options.headers || {};
    options.headers['X-XSRF-Token'] = antiForgeryToken._value;
};

export default antiForgeryToken;
